<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="card-header">
          <h4>Adicionar Cartão</h4>
        </div>
        <div class="row">
          <div class="col-md-2">
            <label for="email">Tipo Cartão</label>
            <select class="form-select" type="text" v-model="state.cartao.tipo_cartao.value">
              <option value="CREDITO">Crédito</option>
            </select>
            <span v-if="state.cartao.tipo_cartao.error" class="text-danger">Este campo é obrigatório</span>
          </div>
          <div class="col-md-2">
            <label for="email">Nome no Cartão </label>
            <input class="form-control" type="text" placeholder="Insira o nome do cartão:"
              v-model="state.cartao.nome_cartao.value" />
            <span v-if="state.cartao.nome_cartao.error" class="text-danger">Este campo é obrigatório</span>
          </div>
          <div class="col-md-2">
            <label for="email">Número</label>
            <input class="form-control" type="text" placeholder="Insira o número do cartão:"
              v-model="state.cartao.num_cartao.value" />
            <span v-if="state.cartao.nome_cartao.error" class="text-danger">Este campo é obrigatório</span>
          </div>
          <div class="col-md-2">
            <label for="email">CVV</label>
            <input class="form-control" type="text" placeholder="Insira o CVV do cartão:" v-mask="'000'"
              v-model="state.cartao.cvv.value" />
            <span v-if="state.cartao.nome_cartao.error" class="text-danger">Este campo é obrigatório</span>
          </div>
          <div class="col-md-2">
            <label for="email">Mês Validade</label>
            <input class="form-control" type="text" v-mask="'00'" placeholder="Insira o mês em número:"
              v-model="state.cartao.mes_validade.value" />
            <span v-if="state.cartao.nome_cartao.error" class="text-danger">Este campo é obrigatório</span>
          </div>
          <div class="col-md-2">
            <label for="email">Ano Validade</label>
            <input class="form-control" type="text" placeholder="Insira o ano de validade do cartão:"  v-mask="'0000'"
              v-model="state.cartao.ano_validade.value" />
            <span v-if="state.cartao.nome_cartao.error" class="text-danger">Este campo é obrigatório</span>
          </div>
        </div>
        <div class="btns_right">
          <button @click="saveCartao" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/clinicas">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
          <button v-if="state.cartao.id" @click="deleteCartao" type="button" class="btn_delete"><svg
              xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash"
              viewBox="0 0 16 16">
              <path
                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
              <path
                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
            </svg></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");

    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchClinica();
      }
    });
    const state = reactive({
      clinica: {},
      cartao: {
        id: "",
        nome_cartao: {
          value: "",
          error: false,
        },
        tipo_cartao: {
          value: "CREDITO",
          error: false,
        },
        num_cartao: {
          value: "",
          error: false,
        },
        cvv: {
          value: "",
          error: false,
        },
        mes_validade: {
          value: "",
          error: false,
        },
        ano_validade: {
          value: "",
          error: false,
        },
      },
    });
    async function fetchClinica() {
      try {
        const { data } = await services.clinica.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.clinica = data;
        state.cartao.id = data.cartao.id;
        state.cartao.nome_cartao.value = data.cartao.holder_name;
        state.cartao.num_cartao.value = data.cartao.number;
        state.cartao.cvv.value = data.cartao.cvv;
        state.cartao.mes_validade.value = data.cartao.exp_month;
        state.cartao.ano_validade.value = data.cartao.exp_year;
        state.cartao.tipo_cartao.value = data.cartao.type;
        if (state.cartao.tipo_cartao.value == 'credit') {
          state.cartao.tipo_cartao.value = 'CREDITO'
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function saveCartao() {
      if (state.cartao.id) {
        alert('Esse profissional já poussí um cartão. Para alterar o cartão, primeiro apague o cartão existente e depois adicione o novo cartão.')
      }
      var erro_validacao = false;
      if (state.cartao.nome_cartao.value.length == 0) {
        state.cartao.nome_cartao.error = true;
        erro_validacao = true;
      };
      if (state.cartao.num_cartao.value.length == 0) {
        state.cartao.num_cartao.error = true;
        erro_validacao = true;
      };
      if (state.cartao.cvv.value.length == 0) {
        state.cartao.cvv.error = true;
        erro_validacao = true;
      };
      if (state.cartao.mes_validade.value.length == 0) {
        state.cartao.mes_validade.error = true;
        erro_validacao = true;
      }
      if (state.cartao.ano_validade.value.length == 0) {
        state.cartao.ano_validade.error = true;
        erro_validacao = true;
      }
      if (erro_validacao == true) {
        return;
      }
      await services.cartao
        .save({
          clinica_id: state.clinica.id,
          pagarme_id: state.clinica.pagarme_id,
          nome: state.cartao.nome_cartao.value,
          numero: state.cartao.num_cartao.value,
          cvv: state.cartao.cvv.value,
          mes_val: state.cartao.mes_validade.value,
          ano_val: state.cartao.ano_validade.value,
          tipo: state.cartao.tipo_cartao.value,
          token,
        })
        .then((data) => {
          router.push({ name: "Clinicas" });
          console.log(data);
        })
        .catch((error) => {
          console.log('error aqui: ' + error);
          console.log(error);
        });
    }
    async function deleteCartao() {
      if (confirm("Deseja realmente apagar o cartão?")) {
        await services.cartao.delete({
          id: state.cartao.id,
          token
        });
        alert('Cartão apagado com sucesso!');
        window.location.reload(); 
      }
    }
    return {
      state,
      saveCartao,
      deleteCartao
    }
  },
}


</script>

<style scoped>
h4 {
  color: #000;
}

label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}

input {
  border: solid 1px #000;
}

input:focus {
  border: solid 1px #47b0a9;
}

select {
  border: solid 1px #000;
}

select:focus {
  border: solid 1px #47b0a9;
}

.btns_right {
  text-align: right;
  margin-top: 1rem;
}

.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_save:hover {
  background: #008000;
}

.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn_cancel:hover {
  background: #8f0303;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

textarea {
  resize: none;
  border: solid 1px #000;
}

textarea:focus {
  border: solid 1px #47b0a9;
}

#pills-home-tab {
  color: #000;
}

#pills-home-tab:focus {
  color: #47b0a9;
}

#pills-profile-tab {
  color: #000000;
}

#pills-profile-tab:focus {
  color: #47b0a9;
}

.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}

tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}

thead {
  color: #000;
  text-align: center;
  background: gray;
}

td {
  color: #000;
  text-align: center;
}

.table {
  margin-top: 2rem;
}

.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}

.btn_delete {
  padding: 5px;
  width: 50px;
  background: yellow;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn_delete:hover {
  background: rgb(180, 180, 18);
}
</style>